import {gql} from "@apollo/client";

export const TFA_OFF_MUTATION = gql(`
    mutation OffTFA($code: String!) {
      offTFA(tfaCode: $code)
    }
`);
